import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=8b259f12&lang=pug&"
import script from "./PaySuccess.vue?vue&type=script&lang=js&"
export * from "./PaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports